import { useLocation } from "react-router";
import { useMemo } from "react";
export function useTypedHash(route) {
    const location = useLocation();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return useMemo(() => route.$deserializeHash(location.hash), [route, location.hash]);
}
